import { useState } from 'react'
import { ReactComponent as Close } from '../assets/icons/close.svg'
import { patchDocumentsRename } from '../apis/document.ts'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'

import Radio from '../assets/icons/radio.svg'
import { ReactComponent as RadioFilled } from '../assets/icons/radio-filled.svg'

function DeleteModal({ close, content, onStateChange, deleteApi }) {
  const textList = {
    class: {
      title: '수업 삭제',
      description:
        '수업을 삭제할 경우 수업에 종속된 차시 및 관련된 수업방이 모두 삭제되며 복구가 불가능합니다.',
      deactivate: '취소',
      activate: '삭제',
    },
    lesson: {
      title: '차시 삭제',
      description: '차시를 삭제할 경우 관련된 수업방이 모두 삭제되며 복구가 불가능합니다.',
      deactivate: '취소',
      activate: '삭제',
    },
    student: {
      title: '수강 학생 삭제',
      description: `삭제를 누를 경우 해당 학생은
이 수업에 접근할 수 없습니다.`,
      deactivate: '취소',
      activate: '삭제',
    },

    lessonEdit: {
      title: '저장되지 않은 수정 내용이 있습니다',
      description: '수정 취소를 진행하시면 지금까지 작성한 내용이 사라집니다.',
      deactivate: '수정 계속하기',
      activate: '정보 수정 취소',
    },
    lessonAdd: {
      title: '저장되지 않은 작성 내용이 있습니다',
      description: '추가 취소를 진행하시면 지금까지 작성한 내용이 사라집니다.',
      deactivate: '작성 계속하기',
      activate: '차시 추가 취소',
    },
    document: {
      title: '자료 삭제',
      description: `삭제를 누를 경우 해당 자료가 완전히 삭제되며 
복구가 불가능합니다.`,
      deactivate: '취소',
      activate: '삭제',
    },
  }
  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_default relative w-[400px] fill-label-default'>
        <Close onClick={close} className='absolute right-20 top-20 h-28 w-28 cursor-pointer' />
        <div className='flex flex-col items-start gap-4'>
          <p className='text-h1-semibold text-label-default'>{textList[content].title}</p>
          <p className='whitespace-pre-wrap text-body1-long-regular text-label-info'>
            {textList[content].description}
          </p>
        </div>
        <div className='flex w-full gap-16'>
          <button onClick={close} className='button_outlined_secondary_lg w-full text-label-sub'>
            {textList[content].deactivate}
          </button>
          <button
            id='button-activate'
            onClick={async () => {
              close()
              await onStateChange()
              ;(await deleteApi) && deleteApi()
              // getApi()
            }}
            className='button_solid_primary_lg w-full bg-red-60'
          >
            {textList[content].activate}
          </button>
        </div>
      </div>
    </div>
  )
}

function RenameModal({ close, getApi, selectedDocument, existingName, ref }) {
  const [newName, setNewName] = useState(existingName)
  const [isRenameErrorOpen, setIsRenameErrorOpen] = useState(false)

  /*************** 자료명 변경 API **************/
  const patchDocumentsRenameApi = async (isOrderName, documentId, newName) => {
    const patchDocumentsRenameResponse = await patchDocumentsRename(
      { isOrderName: isOrderName },
      {
        documentId: documentId,
        newName: newName,
      },
    )

    if (patchDocumentsRenameResponse.error) {
      if (patchDocumentsRenameResponse.error.code === 'E409') {
        setIsRenameErrorOpen(true)
      }
      return
    } else {
      console.log(patchDocumentsRenameResponse.result)
      await close()
      await getApi()
    }
  }
  return (
    <div className='fixed left-0 top-0 z-[1000] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      {isRenameErrorOpen ? (
        <div className='modal_default relative w-[400px]'>
          {/* <Close className='absolute right-20 top-20' /> */}
          <div className='flex flex-col items-start gap-4'>
            <p className='text-h1-semibold text-label-default'>같은 이름의 자료가 존재합니다</p>
            <p className='text-body1-long-regular text-label-info'>
              이름을 변경하시면 버전 숫자 (n)을 삽입한 자료 이름으로 저장됩니다.
            </p>
          </div>
          <div id='modal' className='flex w-full gap-16'>
            <button
              id='cancel'
              onClick={close}
              className='button_outlined_secondary_lg w-full text-label-sub'
            >
              취소
            </button>
            <button
              id='rename'
              onClick={async () => {
                close()
                await patchDocumentsRenameApi(true, selectedDocument[0], newName)
                await getApi()
              }}
              className='button_solid_primary_lg w-full bg-primary-normal'
            >
              변경
            </button>
          </div>
        </div>
      ) : (
        <div className='modal_default relative w-[400px] fill-label-default'>
          <div className='flex flex-col items-start gap-20'>
            <p className='text-h1-semibold text-label-default'>이름 변경</p>
            <div className='relative w-full'>
              <input
                type='text'
                placeholder='파일 이름'
                className='input_default w-full'
                onChange={(e) => {
                  e.preventDefault()
                  setNewName(e.target.value)
                }}
                value={newName}
                autoFocus
              />
              {newName && (
                <CloseFilled
                  onClick={() => setNewName('')}
                  className='absolute right-16 top-16 cursor-pointer'
                />
              )}
            </div>
          </div>
          <div className='flex w-full gap-16'>
            <button onClick={close} className='button_outlined_secondary_lg w-full text-label-sub'>
              취소
            </button>
            <button
              onClick={async () => {
                if (newName === existingName) {
                  close()
                } else {
                  await patchDocumentsRenameApi(null, selectedDocument[0], newName)
                }
              }}
              className={`${newName === '' ? 'button_solid_primary_disabled_lg' : !newName.trim() ? 'button_solid_primary_disabled_lg' : 'button_solid_primary_lg bg-primary-normal'} w-full`}
            >
              변경
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

function OverWriteModal({ close, fileInfo, postApi }) {
  const [action, setAction] = useState('OVERWRITE')
  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_default relative w-[400px] fill-label-default'>
        <div className='flex flex-col items-start gap-24'>
          <div className='flex flex-col items-start gap-4'>
            <p className='text-h1-semibold text-label-default'>같은 이름의 자료가 존재합니다</p>
            <p className='whitespace-pre-wrap text-body1-long-regular text-label-info'>
              하나 이상의 자료가 과목 자료실에 이미 존재합니다.
            </p>
          </div>
          <div className='flex flex-col items-start gap-8'>
            <label className='relative flex items-start gap-8 py-12 pl-8 pr-16 has-[:checked]:rounded-8 has-[:checked]:bg-fill-normal'>
              <input
                checked
                onChange={(e) => setAction(e.target.value)}
                type='radio'
                name='overwrite'
                value='OVERWRITE'
                className='peer h-24 min-w-24 appearance-none bg-center bg-no-repeat checked:invisible'
                style={{
                  backgroundImage: `url(${Radio})`,
                }}
              />
              <RadioFilled className='invisible absolute peer-checked:visible' />
              <div className='flex w-full flex-col items-start justify-center gap-4'>
                <p className='text-h2-semibold text-label-sub'>기존 자료 덮어쓰기</p>
                <p className='text-body2-long-regular text-label-info'>
                  기존에 있는 자료를 새롭게 업로드 하는 자료로 덮어씁니다.
                </p>
              </div>
            </label>
            <label className='relative flex w-full items-start gap-8 py-12 pl-8 pr-16 has-[:checked]:rounded-8 has-[:checked]:bg-fill-normal'>
              <input
                onChange={(e) => setAction(e.target.value)}
                type='radio'
                name='overwrite'
                value='NEW_NAME'
                className='peer h-24 min-w-24 appearance-none bg-center bg-no-repeat checked:invisible'
                style={{
                  backgroundImage: `url(${Radio})`,
                }}
              />
              <RadioFilled className='invisible absolute peer-checked:visible' />
              <div className='flex w-full flex-col items-start justify-center gap-4'>
                <p className='text-h2-semibold text-label-sub'>모든 자료 유지</p>
                <p className='text-body2-long-regular text-label-info'>
                  업로드 하는 자료의 이름에 버전 숫자 (n)을 삽입하여 업로드합니다.
                </p>
              </div>
            </label>
          </div>
        </div>
        <div className='flex w-full gap-16'>
          <button onClick={close} className='button_outlined_secondary_lg w-full text-label-sub'>
            취소
          </button>
          <button
            onClick={(e) => {
              e.preventDefault()
              close()
              postApi(fileInfo, action)
              // setFileInfo([])
            }}
            className='button_solid_primary_lg w-full bg-primary-normal'
          >
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export { DeleteModal, RenameModal, OverWriteModal }
